import ListWidget from "../../../widgets/ListWidgetV2/widget";
import {PropertyPaneStyleConfig} from "../../../widgets/ListWidgetV2/widget/propertyConfig";
import {WidgetType} from "../../../constants/WidgetConstants";
import { PropertyPaneContentConfig } from "./propertyConfig";

class AtListWidgetV2 extends ListWidget{
  static getPropertyPaneContentConfig() {
    return PropertyPaneContentConfig;
  }
  static getPropertyPaneStyleConfig() {
    return PropertyPaneStyleConfig;
  }
  static getWidgetType(): WidgetType {
    return "AT_LIST_WIDGET_V2";
  }
}
export default AtListWidgetV2;
